import type { Ref, WatchSource } from "vue";

export function usePaginationListFocus(
  page: Ref<number>,
  dataSignal: WatchSource,
  targetRef: Ref<HTMLElement | null | undefined>,
) {
  let pendingFocus = false;
  watch(page, (v, prev) => {
    if (v === prev) return;
    pendingFocus = true;
  });
  watch(dataSignal, async () => {
    if (!pendingFocus) return;
    pendingFocus = false;
    await nextTick();
    targetRef.value?.focus({ preventScroll: true });
  });
}
